import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, booting } = useAuth();
  const location = useLocation();

  if (booting) {
    return (
      <div className="flex items-center justify-center min-h-screen text-sm text-zinc-500" data-testid="auth-loading">
        Loading…
      </div>
    );
  }

  // 1. Not logged in -> Redirect to login
  if (!user) return <Navigate to="/auth/login" state={{ from: location }} replace />;

  // 2. Admin User -> Block access to normal user app routes and redirect to /admin
  const isAdmin = user.is_admin || user.is_superuser || user.role === "admin";
  if (isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  // 3. Regular Exhibitor User -> Render requested route
  return children;
}